import React, { useContext, useEffect, useState } from 'react';
import CategoryComponent from 'Pages/GMS/ISR/Components/CategoryComponent';
import CategoryConfigurations from 'Pages/GMS/ISR/Components/CategoryConfigurations';
import RulesComponent from 'Pages/GMS/ISR/Components/Rules/RulesComponent';
import { getCategoryTypeAndCategory } from '../ModelServices/ModalServices';
import { AppContext } from 'Context/AppContext';
import { TTransformation, TConnector, TField, TIndexState, TProductCategory, TSubmodel, TUpsertISRProjectDataModelsInput } from '../model';
import useCategoryConfigurationUpdater from '../Hooks/useCategoryConfigurationUpdater';
import PredictiveComponent from './PredictiveComponent';
import { useLocation } from 'react-router';
import ProductSorting from './ProductSorting';
import { RULE_FUNCTION_CATEGORY } from 'Pages/GMS/ISR/ISRConstants';

type TCategoryFieldProps = {
    id: string;
    selectedItem: TField | TSubmodel | TProductCategory | TConnector | null;
    userProjectDataModels: TUpsertISRProjectDataModelsInput;
    setUserProjectDataModels: React.Dispatch<React.SetStateAction<TUpsertISRProjectDataModelsInput>>;
    indexInfo: TIndexState;
    setSubSelectedItem: React.Dispatch<React.SetStateAction<TTransformation | null>>;
    setIndex?: React.Dispatch<React.SetStateAction<TIndexState>>;
    createISRProject: () => void
}

const CategoryField = ({ id, selectedItem, userProjectDataModels, setUserProjectDataModels, setSubSelectedItem, indexInfo, setIndex, createISRProject }: TCategoryFieldProps) => {
    const appContext = useContext(AppContext);
    const industryId = appContext.get_selected_industry() && appContext?.get_selected_industry()?.id;
    const [categoryTypeList, setCategoryTypeList] = useState<string[]>([]);
    const [categoryData, setCategoryData] = useState([]);
    const location = useLocation();
    const isGuide = Boolean(location.pathname.includes('/guide/'));
    const [showAddAttributeMenu, setShowAddAttributeMenu] = useState<boolean>(false);

    const { updateCategoryConfiguration } = useCategoryConfigurationUpdater({ setUserProjectDataModels });

    const updateFieldDataConfiguration = (updatedConfig: TProductCategory) => {
        const productCategory = selectedItem as TProductCategory;
        updateCategoryConfiguration(indexInfo, updatedConfig, productCategory?.data?.belongsToDataModel ?? false);
    };

    useEffect(() => {
        const fetchCategoryTypesAndCategories = async () => {
            try {
                const response = await getCategoryTypeAndCategory(industryId ?? '');
                if (response?.done) {
                    const categoryTypes = response?.data?.map((item: any) => item?.name);
                    setCategoryData(response?.data);
                    setCategoryTypeList(categoryTypes);
                }
            } catch (e) {
                console.log('Error', e);
            }
        }
        fetchCategoryTypesAndCategories();
    }, [industryId]);

    return (
        <div id={id}>
            <CategoryComponent selectedItem={selectedItem} userProjectDataModels={userProjectDataModels} setUserProjectDataModels={setUserProjectDataModels} indexInfo={indexInfo} />
            <br />
            <CategoryConfigurations categoryTypeList={categoryTypeList} categoryData={categoryData} selectedItem={selectedItem} updateFieldDataConfiguration={updateFieldDataConfiguration} setSubSelectedItem={setSubSelectedItem} setIndex={setIndex} indexInfo={indexInfo} userProjectDataModels={userProjectDataModels} setUserProjectDataModels={setUserProjectDataModels} />
            <br />
            {isGuide && <PredictiveComponent selectedItem={selectedItem} userProjectDataModels={userProjectDataModels} setUserProjectDataModels={setUserProjectDataModels} indexInfo={indexInfo} />}
            <ProductSorting selectedCategory={selectedItem as TProductCategory} showAddAttributeMenu={showAddAttributeMenu} setShowAddAttributeMenu={setShowAddAttributeMenu} updateFieldDataConfiguration={updateFieldDataConfiguration} />
            <br />
            <RulesComponent
                id={`${id}-rules`}
                selectedItem={selectedItem}
                userProjectDataModels={userProjectDataModels}
                setUserProjectDataModels={setUserProjectDataModels}
                indexInfo={indexInfo}
                createISRProject={createISRProject}
                featureType={RULE_FUNCTION_CATEGORY}
            />
            <br />
        </div>
    );
}

export default CategoryField;